import type { Props } from './types';

// NirmalX: the search results page renders the NirmalX shell itself, so it can put its own input in the header.
const LayoutSearchResults = ({ children }: Props) => children;

export default LayoutSearchResults;
